import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const McdDispTrendChart = ({ formValues }) => {

  const { rbtPeriodId, stateIds, ctrtIds, brandProdIds } = formValues;

  const rsrc = useRsrc();
  const [data, setData] = useState();

  const [prodIds, setProdIds] = useState([]);
  const [progIds, setProgIds] = useState([]);

  const { navigateTo } = useNavState();

  const handleClick = (dataPoint) => {
    const rbtPeriodCode = dataPoint.category;
    const rowsReq = {};
    rowsReq.expr = ExprUtils.whereParams('code', rbtPeriodCode);
    rsrc.one('sc', 'PERIOD', rowsReq).then(period => {
      const rbtPeriodId = period.id;
      // let expr = ExprUtils.whereParams('rbtPeriodId', rbtPeriodId);
      let replaceParams = {};
      replaceParams['rbtPeriodId'] = rbtPeriodId;

      if (prodIds.length > 0) {
        // const prodExpr = ExprUtils.whereParams('prodId', prodIds);
        // expr = ExprUtils.and(expr, prodExpr);
        replaceParams['prodIds'] = prodIds;
      }

      if (stateIds.length > 0) {
        const stateExpr = ExprUtils.whereParams('mcdClaimStateId', stateIds);
        stateExpr.fkEntity = 'MCD_CLAIM';
        stateExpr.fkColPrefix = 'mcd_claim';
        // expr = ExprUtils.and(expr, stateExpr);
        replaceParams['stateIds'] = stateIds;
      }

      if (progIds.length > 0) {
        const progExpr = ExprUtils.whereParams('mcdClaimProgId', progIds);
        progExpr.fkEntity = 'MCD_CLAIM';
        progExpr.fkColPrefix = 'mcd_claim';
        // expr = ExprUtils.and(expr, progExpr);
        replaceParams['progIds'] = progIds;
      }

      const navState = {
          mode: Mode.LIST,
          // expr: expr,
          replaceParams: replaceParams,
          query: 'MCD_FIN_TREND_DISPS'
        };
      navigateTo('/sc/mcd-disp', navState);
    });
  }

  useEffect(() => {
    const reqParam = {
      periodId: rbtPeriodId,
      stateIds,
      ctrtIds,
      brandIds: brandProdIds
    };

    rsrc.data('sc', 'MCD_DISP_TREND_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
      setProdIds(data.prodIds);
      setProgIds(data.progIds);
    });
  }, [rbtPeriodId, stateIds, ctrtIds, brandProdIds]);


  return (
    <CartesianChart
      data={data}
      yLabel={'Disputed Dollars'}
      legend={'top'}
      xLabel={'Rebate Period'}
      onClick={(dataPoint) => handleClick(dataPoint)}
    />
  );
};
